import { CampaignListItem } from 'app/src/features/Home/components/CampaignSelectionDialog/CampaignListItem/CampaignListItem'
import type { membershipApi } from 'app/src/services/welfareportal'
import { activeCampaigns, getFromSessionStorage, setToSessionStorage } from 'app/src/shared/helpers/funcutils'
import { useTranslation, useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { DataView } from 'primereact/dataview'
import { Dialog } from 'primereact/dialog'
import { useState } from 'react'

export function CampaignSelectionDialog(props: { onHide: () => void }) {
  const context = useWebAppContext()
  const campaign = getFromSessionStorage('selectedCampaign')
  const campaignStorage = campaign ? JSON.parse(campaign).membershipId : undefined
  const checkedCampaign = context.userInfo.userMemberships.find(
    (m: membershipApi.UserMembership) => m.membershipId === campaignStorage,
  )
  const navigate = useWelfarePortalNavigate()
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.CampaignSelectionDialog' })

  const [selectedCampaign, setSelectedCampaign] = useState<membershipApi.UserMembership | undefined>(checkedCampaign)

  const itemTemplate = (campaign: membershipApi.UserMembership) => {
    return (
      <CampaignListItem
        key={campaign.membershipId}
        campaign={campaign}
        checked={selectedCampaign?.membershipId == campaign.membershipId}
        onSelectionChange={setSelectedCampaign}
      />
    )
  }

  const listTemplate = (items: membershipApi.UserMembership[]) => {
    if (!items || items.length === 0) return null
    const list = activeCampaigns(items).map((campaign) => itemTemplate(campaign))

    return <div className='grid-nogutter grid'>{list}</div>
  }

  return (
    <Dialog
      visible
      onHide={props.onHide}
      closable={campaign ? true : false}
      className='h-[70%]'
      header={t('Title')}
      footer={
        <div>
          <div className='mx-auto mt-6 flex justify-center'>
            {campaign && <Button label={t('CancelButtonLabel')} link onClick={props.onHide} />}
            <Button
              label={t('ConfirmButtonLabel')}
              rounded
              disabled={!selectedCampaign}
              onClick={() => {
                setToSessionStorage('selectedCampaign', JSON.stringify(selectedCampaign))
                context.update({ showCompanySelectionDialog: false })
                props.onHide()
                navigate.goToLanding()
                sessionStorage.setItem('spendingReminderShown', 'true')
              }}
            />
          </div>
        </div>
      }
    >
      <div>
        <div dangerouslySetInnerHTML={{ __html: t('InformativeText') }} />
        <DataView
          value={context.userInfo.userMemberships || []}
          listTemplate={listTemplate}
          emptyMessage={'nessun risultato trovato'}
          totalRecords={context.userInfo.userMemberships.length}
        />
      </div>
    </Dialog>
  )
}
